<template>
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.5679 39.4321C29.0579 35.9221 26.4119 31.9921 24.6539 28.0051C24.2819 27.1621 24.5009 26.1751 25.1519 25.5241L27.6089 23.0701C29.6219 21.0571 29.6219 18.2101 27.8639 16.4521L24.3419 12.9301C21.9989 10.5871 18.2009 10.5871 15.8579 12.9301L13.9019 14.8861C11.6789 17.1091 10.7519 20.3161 11.3519 23.4961C12.8339 31.3351 17.3879 39.9181 24.7349 47.2651C32.0819 54.6121 40.665 59.1661 48.504 60.6481C51.684 61.2481 54.8909 60.3211 57.1139 58.0981L59.0669 56.1451C61.4099 53.8021 61.4099 50.0041 59.0669 47.6611L55.5479 44.1421C53.7899 42.3841 50.9399 42.3841 49.1849 44.1421L46.4759 46.8541C45.8249 47.5051 44.8379 47.7241 43.9949 47.3521C40.0079 45.5911 36.0779 42.9421 32.5679 39.4321Z"
      stroke="currentColor"
      stroke-width="4.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_814_94902"
        x1="11.1733"
        y1="60.8267"
        x2="60.8272"
        y2="11.1759"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8CBDED" />
        <stop offset="0.651042" stop-color="#006187" />
      </linearGradient>
    </defs>
  </svg>
</template>
